(function () {
  function initTrustBarSwipers(root) {
    if (typeof Swiper === 'undefined') {
      return;
    }

    var scope = root || document;
    var swipers = scope.querySelectorAll('[data-trust-bar-swiper]');

    swipers.forEach(function (el) {
      if (el.swiper && el.swiper.destroy) {
        el.swiper.destroy(true, true);
      }

      var autoplay = el.getAttribute('data-autoplay') === 'true';
      var delay = parseInt(el.getAttribute('data-autoplay-delay'), 10) || 3500;
      var loop = el.getAttribute('data-loop') === 'true';

      /* eslint-disable no-new */
      new Swiper(el, {
        slidesPerView: 1,
        loop: loop,
        autoplay: autoplay
          ? {
              delay: delay,
              disableOnInteraction: false,
            }
          : false,
        navigation: {
          nextEl: el.querySelector('.index-trust-bar-swiper__next'),
          prevEl: el.querySelector('.index-trust-bar-swiper__prev'),
        },
        speed: 600,
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTrustBarSwipers();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initTrustBarSwipers(event.target);
  });
})();
